<script lang="ts" setup>
import { LayoutTagGetResponse_WordSetting } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";
import { defineProps, defineEmits } from "vue";

/**
 * いいねUI。
 */

interface Props {
	/**
	 * 投稿が許可されてるかどうか。
	 */
	isPostable: boolean;
	/**
	 * いいね送付後かどうか。
	 */
	isPosted: boolean;
	/**
	 * いいね数。
	 */
	niceCount: number;
	/**
	 * 文字列設定
	 */
	wordSettings?: LayoutTagGetResponse_WordSetting | null;
}
defineProps<Props>();

interface Emits {
	(e: "on-click-nice"): void;
}
const emit = defineEmits<Emits>();
const onclick = (): void => {
	emit("on-click-nice");
};
</script>

<template>
	<div class="revico-community-talk-reply-details-nice-wrapper">
		<!-- いいね送付前のUI -->
		<p class="revico-community-talk-reply-details-nice postable" @click="onclick" v-if="isPostable && !isPosted">
			{{ wordSettings?.likeButtonLabel }}
			<font-awesome-icon icon="fa-solid fa-thumbs-up" />
			{{ niceCount }}
		</p>
		<!-- いいね送付後のUI -->
		<p class="revico-community-talk-reply-details-nice thanks" v-else-if="isPostable && isPosted">
			{{ wordSettings?.likePostedText }}
			<font-awesome-icon icon="fa-solid fa-thumbs-up" />
		</p>
		<!-- いいね押下不可のUI -->
		<p class="revico-community-talk-reply-details-nice disabled" v-else>
			{{ wordSettings?.likeButtonLabel }}
			<font-awesome-icon icon="fa-solid fa-thumbs-up" />
			{{ niceCount }}
		</p>
	</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk .revico-community-talk {
	&-reply-details-nice-wrapper {
		width: 100%;
		margin-top: 4px;
		text-align: right;
	}

	&-reply-details-nice {
		display: inline;
		font-size: 0.8em;
		cursor: pointer;

		&.thanks {
			cursor: auto;
		}

		&.disabled {
			cursor: auto;
		}

		.fa-thumbs-up {
			margin: 0 8px 0 0;
			font-size: 1.2em;
			opacity: 0.6;
		}
	}
}
</style>
